const handles_phase_builder_selection = {
    methods: {
        reset_phase_builder () {
            this.phase_builder_data = {}
        },
        update_phase_builder_data (phase_id, value, field) {
            if(typeof this.phase_builder_data[phase_id] === "undefined") this.$set(this.phase_builder_data, phase_id, {})
            this.$set(this.phase_builder_data[phase_id], field, value)

            const project_phase = this.phase_builder_data[phase_id]
            if((field === "starts_at") && !project_phase.ends_at) this.$set(this.phase_builder_data[phase_id], "ends_at", this.$moment(value).add(1, "day").format("YYYY-MM-DD"))
            else if((field === "ends_at") && !project_phase.starts_at) this.$set(this.phase_builder_data[phase_id], "starts_at", this.$moment(value).subtract(1, "day").format("YYYY-MM-DD"))
        },
        apply_phase_builder () {
            const phases = {
                ...this.phase_builder_data
            }

            this.$store.dispatch("RECORD_ACTION", {
                entity: "project",
                id: this.record.id,
                action: "create_phases",
                data: {
                    scope_id: this.scope_id,
                    phases
                },
                method: "post"
            }).then(() => {
                this.close()
            }).catch(error => {
                this.$error(error.message)
            })
        },
        close () {
            this.adding_phases = false
        }
    },
    computed: {
        scope_id () {
            return null
        },
        has_phase_builder_selection () {
            const phases = Object.values(this.phase_builder_data)
            if(!!phases && !!phases.length) {
                for(let loop = 0; loop < phases.length; loop++) {
                    const values = Object.values(phases[loop])
                    if(!!values && !!values.find(value => !!value)) return true
                }
            }
            return false
        }
    },
    data () {
        return {
            phase_builder_data: {},
            adding_phases: false
        }
    }
}

export default handles_phase_builder_selection
